import {
  BookingSearchFiltersV2,
  BookingSearchV2Request,
} from '../Types/bookingSearchTypes';

interface BookingSearchPagination {
  page: number;
  pageSize: number;
}

const normalizeTextFilter = (value: string): string | undefined => {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const parseOptionalPositiveInt = (value: string): number | undefined => {
  const trimmed = value.trim();

  if (trimmed.length === 0) {
    return undefined;
  }

  const parsed = Number(trimmed);
  return Number.isInteger(parsed) && parsed >= 1 ? parsed : undefined;
};

const mapPublishedFilter = (value: string): boolean | undefined => {
  if (value === '1') {
    return true;
  }

  if (value === '0') {
    return false;
  }

  return undefined;
};

export const mapBookingSearchFiltersToRequest = (
  filters: BookingSearchFiltersV2,
  pagination: BookingSearchPagination
): BookingSearchV2Request => {
  const pageNumber = Math.max(pagination.page + 1, 1);
  const searchTerm = normalizeTextFilter(filters.searchTerm);
  const offerId = parseOptionalPositiveInt(filters.offerId);
  const companyId = parseOptionalPositiveInt(filters.companyId);
  const applicant = normalizeTextFilter(filters.applicant);
  const participant = normalizeTextFilter(filters.participant);
  const applicantCity = normalizeTextFilter(filters.applicantCity);
  const published = mapPublishedFilter(filters.published);
  const startDateFrom = filters.startDateFrom || undefined;
  const startDateTo = filters.startDateTo || undefined;
  const numberOfParticipants = parseOptionalPositiveInt(filters.numberOfParticipants);

  return {
    ...(searchTerm !== undefined && { searchTerm }),
    ...(offerId !== undefined && { offerId }),
    ...(companyId !== undefined && { companyId }),
    ...(applicant !== undefined && { applicant }),
    ...(participant !== undefined && { participant }),
    ...(applicantCity !== undefined && { applicantCity }),
    ...(published !== undefined && { published }),
    ...(startDateFrom !== undefined && { startDateFrom }),
    ...(startDateTo !== undefined && { startDateTo }),
    dateFilterMode: filters.dateFilterMode,
    ...(numberOfParticipants !== undefined && { numberOfParticipants }),
    ...(filters.includeCancelled === true && { includeCancelled: true }),
    pageNumber,
    pageSize: pagination.pageSize,
  };
};
